export const DISPLAY_NAME_PREFIX = '__displayName';
export const VALIDATE_ERROR_PREFIX = '__validateError';
export const VALIDATORS_NAME_PROP = '__validators';
export const VALIDATION_ERROR_NAME_PROP = '__validationErrors';
export const IS_VALID_FORM_NAME_PROP = '__isValidForm';
export const ERROR_FIELDS_NAME_PROP = '__errorFields';
